import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    GENDER_SET_VALUE,
    GENDER_SET_VALID,
    FIRST_NAME_SET_VALUE,
    FIRST_NAME_SET_VALID,
    LAST_NAME_SET_VALUE,
    LAST_NAME_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    NATIONALITY_SET_VALUE,
    NATIONALITY_SET_VALID,
    OCCUPATION_SET_VALUE,
    OCCUPATION_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    PASSPORT_NUMBER_SET_VALUE,
    PASSPORT_NUMBER_SET_VALID,
    PASSPORT_EXPIRY_SET_VALUE,
    PASSPORT_EXPIRY_SET_VALID,
    PASSPORT_ORIGIN_SET_VALUE,
    PASSPORT_ORIGIN_SET_VALID,
    TIN_NUMBER_SET_VALUE,
    TIN_NUMBER_SET_VALID,
    POSTAL_ADDRESS_SET_VALUE,
    POSTAL_ADDRESS_SET_VALID,
    FORM_VALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM,
    FORM_INVALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM,
    COLLECT_PERSONAL_DETAILS_FORM_DATA,
    API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
    SUBMIT_PERSONAL_DETAILS_SUCCESS,
    SUBMIT_PERSONAL_DETAILS_FAILURE,
    API_PENDING_TRANSITION_NATIONALITIES,
    API_SUCCESS_TRANSITION_NATIONALITIES,
    API_FAILURE_TRANSITION_NATIONALITIES,
    SET_NATIONALITIES_VALUE,
    MARITAL_STATUS_SET_VALUE,
    MARITAL_STATUS_SET_VALID,
    RESIDENTIAL_STATUS_SET_VALUE,
    RESIDENTIAL_STATUS_SET_VALID,
    TOWN_SET_VALUE,
    TOWN_SET_VALID,
    ADDRESS_SET_VALUE,
    ADDRESS_SET_VALID,
    SELECTED_FORM_SET_VALUE,
    CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS,
    FORM_SUCCESS_TRANSITION_LEADS,
    FORM_SUBMITTING_TRANSITION_LEADS,
    FORM_ERROR_TRANSITION_LEADS,
} from '../../actions/naMotorInsurance/personalDetails';

export const initPersonal = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    nationalities: null,
    natiolalityApiCallStatus: null,
    apiCallStatus: null,
    leadsEmailStatus: null,
    selectedForm: 'personalDetails',
    blacklisted: {
        value: null,
        error: null,
        status: null,
    },
    form: {
        gender: { value: null, error: null, status: null },
        firstName: { value: null, error: null, status: null },
        lastName: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        nationality: { value: null, error: null, status: null },
        occupation: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        passportNumber: { value: null, error: null, status: null },
        passportExpiry: { value: null, error: null, status: null },
        passportOrigin: { value: null, error: null, status: null },
        tinNumber: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        postalAddress: { value: null, error: null, status: null },
        maritalStatus: { value: null, error: null, status: null },
        residentialStatus: { value: null, error: null, status: null },
        town: { value: null, error: null, status: null },
        address: { value: null, error: null, status: null },
    },
};

export default (state = initPersonal, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_PENDING_TRANSITION_NATIONALITIES:
            return { ...state, natiolalityApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_NATIONALITIES:
            return { ...state, natiolalityApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_NATIONALITIES:
            return { ...state, natiolalityApiCallStatus: API_CALL_STATUS.FAILURE };

        case SET_NATIONALITIES_VALUE:
            return { ...state, nationalities: action.value };

        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case LAST_NAME_SET_VALUE:
            return updateFormField('lastName', (field) => ({
                ...field,
                value: action.value,
            }));
        case LAST_NAME_SET_VALID:
            return updateFormField('lastName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case GENDER_SET_VALUE:
            return updateFormField('gender', (field) => ({ ...field, value: action.value }));

        case GENDER_SET_VALID:
            return updateFormField('gender', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));

        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));

        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case NATIONALITY_SET_VALUE:
            return updateFormField('nationality', (field) => ({
                ...field,
                value: action.value,
            }));

        case NATIONALITY_SET_VALID:
            return updateFormField('nationality', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OCCUPATION_SET_VALUE:
            return updateFormField('occupation', (field) => ({
                ...field,
                value: action.value,
            }));

        case OCCUPATION_SET_VALID:
            return updateFormField('occupation', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_NUMBER_SET_VALUE:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case PASSPORT_NUMBER_SET_VALID:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_EXPIRY_SET_VALUE:
            return updateFormField('passportExpiry', (field) => ({
                ...field,
                value: action.value,
            }));

        case PASSPORT_EXPIRY_SET_VALID:
            return updateFormField('passportExpiry', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_ORIGIN_SET_VALUE:
            return updateFormField('passportOrigin', (field) => ({
                ...field,
                value: action.value,
            }));

        case PASSPORT_ORIGIN_SET_VALID:
            return updateFormField('passportOrigin', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TIN_NUMBER_SET_VALUE:
            return updateFormField('tinNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case TIN_NUMBER_SET_VALID:
            return updateFormField('tinNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case POSTAL_ADDRESS_SET_VALUE:
            return updateFormField('postalAddress', (field) => ({
                ...field,
                value: action.value,
            }));

        case POSTAL_ADDRESS_SET_VALID:
            return updateFormField('postalAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MARITAL_STATUS_SET_VALUE:
            return updateFormField('maritalStatus', (field) => ({ ...field, value: action.value }));

        case MARITAL_STATUS_SET_VALID:
            return updateFormField('maritalStatus', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case RESIDENTIAL_STATUS_SET_VALUE:
            return updateFormField('residentialStatus', (field) => ({
                ...field,
                value: action.value,
            }));

        case RESIDENTIAL_STATUS_SET_VALID:
            return updateFormField('residentialStatus', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TOWN_SET_VALUE:
            return updateFormField('town', (field) => ({
                ...field,
                value: action.value,
            }));

        case TOWN_SET_VALID:
            return updateFormField('town', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ADDRESS_SET_VALUE:
            return updateFormField('address', (field) => ({
                ...field,
                value: action.value,
            }));

        case ADDRESS_SET_VALID:
            return updateFormField('address', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS:
            return {
                ...state,
                blacklisted: {
                    ...state.blacklisted,
                    value: action.value,
                    status: API_CALL_STATUS.SUCCESS,
                },
            };

        case SELECTED_FORM_SET_VALUE:
            return { ...state, selectedForm: action.value };

        //    API Calls
        case API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };
        case FORM_SUCCESS_TRANSITION_LEADS:
            return {
                ...state,
                leadsEmailStatus: API_CALL_STATUS.SUCCESS,
            };
        case FORM_SUBMITTING_TRANSITION_LEADS:
            return {
                ...state,
                leadsEmailStatus: API_CALL_STATUS.PENDING,
            };
        case FORM_ERROR_TRANSITION_LEADS:
            return {
                ...state,
                leadsEmailStatus: API_CALL_STATUS.FAILURE,
            };

        // Submit user data
        case COLLECT_PERSONAL_DETAILS_FORM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case SUBMIT_PERSONAL_DETAILS_SUCCESS:
            return { ...state, personalDetailsReferenceData: action.value };
        case SUBMIT_PERSONAL_DETAILS_FAILURE:
            return { ...state, personalDetailsReferenceData: action.error };

        // Reset the state
        case REINITIALIZE:
            return initPersonal;
        default:
            return state;
    }
};
